import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CategoriasProvider, { CategoriasContext } from '../../context/CategoriasContext';

function CategoriaDesplegada({ subcategoria, categoria, setCategoriaDesplegada, desplegar, setMenuAbierto }) {
  const navigate = useNavigate();
  const { actualizarCategorias,actualizarSubCategorias, actualizarTercerasCategorias } = useContext(CategoriasContext);

  const handleCategoriaClick = (categoria, subcategoria, terceraCategoria) => {
    desplegar && setMenuAbierto(false)
    let array = [categoria, subcategoria, terceraCategoria]
    actualizarCategorias(array)
    const arraySubCategorias = categoria.subcategorias.map(sc => sc);
    actualizarSubCategorias(arraySubCategorias)
    const arrayTerceras = subcategoria.terceraCategoria.map(tc => tc);
    actualizarTercerasCategorias(arrayTerceras)
    setCategoriaDesplegada(false)
    navigate(('/productos'), { state: { deCategorias: true } });
  };
  
  const handleVerMasClick = (categoria,subcategoria) => {
    let array = [categoria, subcategoria]
    actualizarCategorias(array)
    const arrayTerceras = subcategoria.terceraCategoria.map(tc => tc);
    actualizarTercerasCategorias(arrayTerceras)
    setCategoriaDesplegada(false)
     navigate(('/productos'), { state: { deCategorias: true } });

  }

  const primeros4 = subcategoria.terceraCategoria.slice(0, 4);

  return (
    desplegar?
    <div className='flex flex-col w-full h-full mx-2'>
      <div className='w-60 text-center p-2'>
        <h2 className='text-xs lg:text-sm border-b border-b-Verde font-bold p-2'>{subcategoria.nombre}</h2>
      </div>
      <div className='p-3 w-full'>
        <ul>
          { subcategoria.terceraCategoria.map((tc, index) => (
            <li key={index} className='text-xs lg:text-sm my-1 text-GrisOscuro'>
              <button onClick={() => handleCategoriaClick(categoria,subcategoria,tc)}>{tc.nombre}</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
      :
    <div className='hidden md:flex md:flex-col md:m-2 md:w-80 md:h-56 '>
      <div className='w-full text-center p-2'>
        <h2 className='text-xs lg:text-sm border-b border-b-Verde font-bold p-2'>{subcategoria.nombre}</h2>
      </div>
      <div className='p-3'>
        <ul>
          {primeros4.map((tc, index) => (
            <li key={index} className='text-xs lg:text-sm my-1 text-GrisOscuro'>
              <button onClick={() => handleCategoriaClick(categoria,subcategoria,tc)}>{tc.nombre}</button>
            </li>
          ))}
          {subcategoria.terceraCategoria.length > 4 && (
            <div className='w-full text-start'>
              <li className='mt-2 text-xs lg:text-sm text-Verde font-bold'>
                <button onClick={()=>handleVerMasClick(categoria,subcategoria)}>Ver Más...</button>
              </li>
            </div>
          )}
        </ul>
      </div>
    </div>
  );
}

export default CategoriaDesplegada;
